import { about } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1">
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">
              {about.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {about.content}
            </p>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="w-full max-w-[440px] aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20news%20aggregation%20platform%20abstract%20art%20with%20warm%20beige%20and%20coral%20gradient%2C%20multiple%20floating%20information%20cards%20motif%2C%20soft%20editorial%20design%2C%20clean%20minimal%20composition%2C%20harmonious%20warm%20tones%2C%20no%20text&width=880&height=660&seq=about-img&orientation=landscape"
                alt="在线吃瓜平台介绍"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}